<template>
  <a
      class="btn btn-primary btn-xlg"
      :href="redirectUrl"
      data-testid="buynowbutton"
  >
    <slot>{{ $t('calculator.buyNow') }}</slot>
  </a>
</template>

<script>
import UrlGenerator from '@paybis/frontend-common-lib/src/services/url';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'CalculatorBuyNow',
  props: {
    linkParams: { type: Object, required: false, default: {} }
  },
  computed: {
    ...mapState('calculator', [
      'isGuestUser',
      'availableCryptoCurrencies',
      'selectedCryptoCurrency',
      'selectedAmount',
      'selectedFiatCurrency',
    ]),
    ...mapGetters('calculator', ['getAvailableCryptoCurrencyByCode']),
    ...mapState('calculator', ['isCorporateAccount', 'defaultBuyLink']),
    redirectUrl () {
      const { links } = this.selectedCryptoCurrency;
      const exchangeLink = this.isGuestUser ? '' : '/member/exchange';

      if (this.isCorporateAccount) {
        return this.defaultBuyLink;
      }
      if (!links?.buy) {
        const queryString = new URLSearchParams(this.linkParams).toString();
        return UrlGenerator.generate(`${exchangeLink}/?${queryString}`, {}, this.$i18n.locale);
      }
      this.linkParams.currency = this.selectedFiatCurrency.code;
      const queryString = new URLSearchParams(this.linkParams).toString();

      return UrlGenerator.generate(`${exchangeLink}${links.buy}?${queryString}`, {}, this.$i18n.locale);
    },
  },
};
</script>
